module.exports = __webpack_public_path__ + "img/arrow-swap-horizontal.1ea18646.svg";